import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import {
  IconChevronDownComponent,
  IconClockComponent,
  IconComponent,
} from '@pedix-workspace/angular-ui-icons';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';

@Component({
  selector: 'pxw-cart-category-shell',
  templateUrl: './cart-category-shell.component.html',
  styleUrls: ['./cart-category-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
    IconChevronDownComponent,
    IconClockComponent,
    AlertComponent,
    ButtonComponent,
  ],
})
export class CartCategoryShellComponent {
  readonly headerLabel = input.required<string>();
  readonly productCount = input.required<number>();
  readonly readOnly = input(false);
  readonly stickyHeader = input(false);
  readonly displayHeader = input(true);
  readonly isCategoryAvailable = input.required<boolean>();
  readonly unavailableAlertText = input.required<string>();
  readonly checkScheduleLabel = input.required<string>();

  readonly openAvailability = output<void>();

  protected readonly collapsed = signal(false);

  protected toggle(): void {
    this.collapsed.update(value => !value);
  }
}
